import React, { Component } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PubSub from 'pubsub-js'
import Delayed from './delay'
import Header from './header/header';
import Sidebar from './slidebar/sidebar';
import AreaSet from '../areaSet/areaSet';
import DeviceSet from '../deviceSet/deviceSet';
import Schedule from '../schedule/schedule';
import Energy from '../energy/energy';
import Alarm from '../alarm/alarm';
import "./admin.less";
import { connect } from 'react-redux'
import { createDeletUserInfoAction } from '../../redux/action_craetors/login_action'
import { OUTPUT_PROFILE_DIALOG_SHOW, OUTPUT_PROFILE_DIALOG_HIDE, deviceNo, SPIN_DIALOG_Devices_SHOW, SPIN_DIALOG_Devices_HIDE, SPIN_DIALOG_SHOW, SPIN_DIALOG_HIDE, PERMISSION_DIALOG_HIDE, Attention_DIALOG_SHOW, Attention_DIALOG_HIDE, PERMISSION_DIALOG_SHOW } from "../../const/infoConst"
import OutputFileDialog from "./dialog/outputFileDialog";
import SpinDialog from "./dialog/spinDialog";
import SpinDialogDevices from "./dialog/spinDialogDevices";
import PermissionDialog from "./dialog/permissionDialog";
import AttentionDialog from "./dialog/attentionDialog";
import { meshLog, SPRemove, SPGet, SPSet } from "../../utils/spUtils";
import Mqtt from '../../utils/mqtt';
import { hexToNegativeDecimal, bigEndianToLittleEndian } from '../../utils/dataUtils'
import { changeSelectBuilding, loadBuildDataAndUpdateUI } from "../../utils/net/netUtils";
import { savMqttGroupInfor, savMqttDevicesInfor } from '../../utils/homeUtils'



class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOutputDiaolg: 'hidden', //'visible'
      permissDiaolg: 'none', //"flex" : "none"
      showSpin: 'none', //"flex" : "none"
      showSpinDevices: 'none', //"flex" : "none"
      showAttention: 'none', //"flex" : "none"
    };
  }



  componentDidMount() {
    //广播弹窗--显示
    PubSub.subscribe(OUTPUT_PROFILE_DIALOG_SHOW, (msg, index) => {  //导出文件
      this.setState({
        showOutputDiaolg: 'visible',
      })
    })
    PubSub.subscribe(PERMISSION_DIALOG_SHOW, (msg, index) => { //权限分享框
      this.setState({
        permissDiaolg: 'flex',
      })
    })
    PubSub.subscribe(SPIN_DIALOG_SHOW, (msg, index) => { //加载框
      this.setState({
        showSpin: 'flex',
      })
    })
    PubSub.subscribe(Attention_DIALOG_SHOW, (msg, index) => { //警示弹框
      this.setState({
        showAttention: 'flex',
      })
    })

    PubSub.subscribe(SPIN_DIALOG_Devices_SHOW, (msg, index) => { //加载框
      this.setState({
        showSpinDevices: 'flex',
      })
    })
    PubSub.subscribe(SPIN_DIALOG_Devices_HIDE, (msg, index) => { //加载框
      this.setState({
        showSpinDevices: 'none',
      })
    })

    //广播弹窗--隐藏
    PubSub.subscribe(OUTPUT_PROFILE_DIALOG_HIDE, (msg, index) => { //导出文件
      this.setState({
        showOutputDiaolg: 'hidden',
      })
    })
    PubSub.subscribe(PERMISSION_DIALOG_HIDE, (msg, index) => { //权限分享框
      this.setState({
        permissDiaolg: 'none',
      })
    })
    PubSub.subscribe(SPIN_DIALOG_HIDE, (msg, index) => { //加载框
      this.setState({
        showSpin: 'none',
      })
    })
    PubSub.subscribe(Attention_DIALOG_HIDE, (msg, index) => { //警示弹框
      this.setState({
        showAttention: 'none',
      })
    })

    //ui相关

    meshLog('admin渲染第一步',);
    meshLog('admin.jsx,113行,从父类传过来的所有数据', this.props);//从父类传过来的props

    loadBuildDataAndUpdateUI();
    PubSub.subscribe("reloadBuildingData", (msg, index) => { //新建Building后刷新数据
      loadBuildDataAndUpdateUI();
    })
    PubSub.subscribe("reloadMeshData", (msg, index) => { //更新Mesh后刷新数据
      let buildingName = SPGet("SelectBuildingName");
      changeSelectBuilding(buildingName, SPGet("SelectMeshName"));
    })


    PubSub.unsubscribe("mqttLink")
    PubSub.subscribe('mqttLink', (msg, data) => {
      meshLog('解密成功，所需要的网关', data);
      meshLog('mqtt开始链接',);
      this.mqttlinkSucess()
    })
    //10秒之后mqtt链接
    setTimeout(() => {
      meshLog('原本的mqtt开始链接,留着备用',);
    }, 5000)


    //退出
    PubSub.unsubscribe("deletUser")
    PubSub.subscribe('deletUser', (msg, data) => {
      this.props.deletUser()
    })
  }


  mqttlinkSucess = () => {
    meshLog('mqttlinkSucess执行',);
    // 成功的mqtt开始
    let mqttpandun = 0//用来进行mqtt判断，如果一直是0，就说明mqtt没收到信息，这就要修改OK弹框
    const username = (SPGet("email"))
    const password = (SPGet("password"))
    var mqtt = new Mqtt("iot.hsesmartinc.com:3100", {
      username: username,
      password: password
    });//里面写上ip和端口
    //在获取网关之后再链接mqtt,获取订阅主题的
    const wangguan = JSON.parse(SPGet("wangguan"))
    const wangguanmac = bigEndianToLittleEndian(wangguan.macAddress)
    meshLog('wangguan88', wangguan);
    //var mqtt = new Mqtt("44.204.237.47:3100");//里面写上正式ip和端口 测试服务器 test.hsesmartinc.com    正式服务器 iot.hsesmartinc.com
    //var Wed_Send = "web-gateway";//这里就是网页发的主题
    var gateway_web = wangguanmac + "/gateway-web";//这里就是网关主题


    let intervalId; // 用于存储间隔的ID

    function startTimer(interval) {
      intervalId = setInterval(function () {
        console.log("执行操作，刷新网页");
        // 这里可以放置你想在间隔结束后执行的代码 刷新网页
        // 如果需要在每次操作后重新开始计时，可以在这里调用stopAndRestartTimer()函数
        window.location.reload();
      }, interval);
    }

    function stopAndRestartTimer(interval) {
      clearInterval(intervalId); // 停止当前的间隔
      startTimer(interval); // 重新开始计时
      meshLog('重新开始',);
    }

    // 初始化计时器
    startTimer(1200000); // 例如，这里设置为1200秒

    // 假设这是你的操作函数，每发生一次就重置计时器
    function handleOperation() {

    }


    mqtt.link().then((client) => {//封装成promsie方便使用
      //client这里保留了原生的client函数和用法
      var sendMess = { //这就是要传给后端的参数
        // MessageId: topic,
        // TopicId: topic,
        // Time: new Date().getTime(),
        //test: 456,//这个mqtt是生成随机生成的随机数
        //当然要想申请新的随机数可以mqtt.random()
      };
      //mqtt.subscribe(Wed_Send);//订阅主题
      mqtt.subscribe(gateway_web);//订阅主题
      // mqtt.subscribe(topic + "/" + mqtt.clientId);//订阅主题
      //mqtt.publish(topic, sendMess, { qos: 0 })//向某个主题发送消息
      // 在函数外定义，确保全局共享
      let otaTimer = null;
      meshLog('gateway_web109', gateway_web);
      mqtt.onMessage(function (data, gateway_web) {
        console.log("操作发生，重新计时");
        stopAndRestartTimer(1200000); // 重新设置间隔为10秒
        meshLog("mqtt回传之后的信息1111", data);
        meshLog("mqtt回传之后的信息1111", data.length);
        if (data[0] == '2') {
          //ota判断逻辑开始
          console.log('data 类型:', typeof data, '值:', data);
          const versionPanduan1 = data.slice(46, 50)
          const OTAPanduan = data.slice(12, 16)
          const versionPanduan2 = data.slice(38, 40)
          const OTApid = JSON.parse(SPGet("OTApid"))
          const versionPanduan3 = data.slice(50, 54)
          if (versionPanduan3 == OTApid && versionPanduan1 == '0F00' && versionPanduan2 == '00') {
            const hexStr = data.slice(40, 42)
            const hexStrValue = hexToNegativeDecimal(hexStr)
            const OTAValue = JSON.parse(SPGet("OTAValue"))
            meshLog('OTAValue', OTAValue);
            const OTAMACValue = data.slice(12, 24)
            meshLog('OTAValueOTAMAC', OTAMACValue);
            meshLog('hexStrValue', hexStrValue);

            if (hexStrValue > OTAValue) {
              SPRemove("OTAValue")
              SPSet("OTAValue", hexStrValue)
              SPRemove("OTAMAC")
              SPSet("OTAMAC", OTAMACValue)
            }

            // ✅ 延时发布逻辑
            if (otaTimer) {
              clearTimeout(otaTimer);
              console.log(`[DEBUG] 10秒内收到新消息，清除之前定时器，重置倒计时`);
            } else {
              console.log(`[DEBUG] 第一次收到OTA消息，启动10秒定时器`);
            }

            otaTimer = setTimeout(() => {
              PubSub.publish("OTAfrist", data);
              console.log(`[DEBUG] 10秒无新消息，触发发布 OTAfrist`);
              otaTimer = null;
            }, 3000);
          }
          if (OTAPanduan == '0330') {
            meshLog('OTAPanduan', OTAPanduan);
            PubSub.publish('OTASecond', data)//直接控制OK弹框
          }
          //ota判断逻辑结束
        } else if (data[0] == '3') {
          meshLog('获取所有设备最新状态成功', data);
        } else {
          meshLog('datadata', data);
          //获取状态，要在细分是组还是单灯
          console.log('data 类型190:', typeof data, '值:', data);
          if (data.groupList == undefined) {
            //将mqtt获取到的灯状态发给灯页面
            //x先更新前端数据库的数据
            const devicess = (data.devices)
            if (devicess == '' || devicess == undefined) {
              // console.error("Input must be a string");
              return '';
            }
            meshLog('mqtt返回的device', data.devices);
            for (let i = 0; i < devicess.length; i++) {
              savMqttDevicesInfor(devicess[i])
            }
            //这边要在deviceDetailPage写逻辑
            PubSub.publish("mqttDeviceState", data);
            PubSub.publish("mqttDeviceStateEemergency", data);
          } else {
            meshLog('groupList', data.groupList);
            //x先更新前端数据库的数据
            const groupList = data.groupList
            if (groupList) {
              for (let i = 0; i < groupList.length; i++) {
                savMqttGroupInfor(groupList[i])
              }
              //将mqtt获取到的组状态发给组页面
              PubSub.publish("mqttGroupState", data);
            }

          }
        }
      });

      //10秒之后进行判断mqtt有没有收到信息
      setTimeout(() => {
        if (mqttpandun == 0) {

          meshLog('admin.jsx,189行,mqtt没有收到数据了');
          PubSub.publish('mqttguanbi2', '')//直接控制OK弹框
        } else {
          meshLog('admin.jsx,193行,mqt收到数据了');
          PubSub.publish('mqttguanbi', '')//直接控制OK弹框
        }
      }, 10000)
      //10秒之后进行判断mqtt有没有收到信息结束
    });
    // 成功的mqtt
    //关闭mqtt信息
    PubSub.unsubscribe("clearmqtt")
    PubSub.subscribe('clearmqtt', (msg, index) => {
      mqtt.disconnect()
      meshLog('关闭mqtt方法执行',);
    })
    //开关灯，控灯指令，需要延迟320毫秒
    //和网关交互不需要延迟，这边需要区分
    PubSub.unsubscribe("showUpdate")
    PubSub.subscribe('showUpdate', (msg, data) => {
      const wangguan = JSON.parse(SPGet("wangguan"))
      const wangguanmac = bigEndianToLittleEndian(wangguan.macAddress)
      const Wed_Send = wangguanmac + '/web-gateway';//这里就是网页发的主题  测试服务器 3.19.244.79
      meshLog('Wed_Send', Wed_Send);
      meshLog('wangguan', wangguan);
      meshLog('msg', data);
      setTimeout(() => {
        mqtt.publish(Wed_Send, data, { qos: 0 })//向某个主题发送消息
      }, 320)
    })

  }


  controlMenuOpen = () => {
    PubSub.publish('controlMenuOpen', '')
  }

  render() {
    const { isLogin } = this.props.userInfo
    if (!isLogin) {
      return <Navigate replace to="/login" />
    }
    else {
      return (
        <div className='appLayout'>
          <div className="mainTop"><Header /></div>
          <div className='mainSection'>
            <div className='sidebar'>
              <Sidebar />
            </div>
            <div className='content' onClick={() => { this.controlMenuOpen() }} >
              <Routes>
                <Route path="/" element={
                  <Delayed waitBeforeShow={4000}>
                    <AreaSet />
                  </Delayed>
                } />
                <Route path="/control" element={<AreaSet />} />
                <Route path="/setting" element={<DeviceSet />} />
                <Route path="/schedule" element={<Schedule />} />
                <Route path="/energy" element={<Energy />} />
                <Route path="/alarm" element={<Alarm />} />
              </Routes>
            </div>
          </div>

          {/* 全局弹窗 */}
          <div className="output_dialog" style={{ visibility: this.state.showOutputDiaolg }}><OutputFileDialog /></div>
          <div className="perminss_dialog" style={{ display: this.state.permissDiaolg }}><PermissionDialog /></div>
          <div className="spin_dialog" style={{ display: this.state.showSpin }}><SpinDialog /></div>
          <div className="spin_dialog" style={{ display: this.state.showSpinDevices }}><SpinDialogDevices /></div>
          <div className="sche_dialog" style={{ display: this.state.showAttention }}><AttentionDialog /></div>


        </div>
      )
    }
  }
}

export default connect(
  state => ({ userInfo: state }),
  { deletUser: createDeletUserInfoAction }
)(Admin)
